var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"record-details-toolbar"},[_c('div',{staticClass:"left"},[(_vm.editMode)?_c('div',{staticClass:"edit-mode-label"},[_vm._v(" "+_vm._s(_vm.$t('common.labels.editMode'))+" ")]):_vm._t("left")],2),_c('div',{staticClass:"right"},[_vm._t("right")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }